import React, { useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { useFormsContext } from 'pages/forms/context/FormsProvider';
import { useStyles } from './styles';
import { InjectedRouter } from 'react-router';
import { IconButton, Tooltip } from '@material-ui/core';

interface IProps {
  rowIndex: number;
  router: InjectedRouter;
}

export const EditButton = ({ rowIndex, router }: IProps) => {
  const { data } = useFormsContext();
  const styles = useStyles();

  const rowData = useMemo(() => {
    return data[rowIndex];
  }, [data, rowIndex]);

  const isButtonDisabled = useMemo(() => {
    if (!rowData) return false;
    return (
      rowData.inDraft === 'N' || rowData.inCanceled === 'S' || rowData.inPublished === 'S' || rowData.inInactive === 'S'
    );
  }, [rowData]);

  const handleEdit = () => {
    router.push(`/formularios/editar/${rowData.idForm}`);
  };

  return (
    <Tooltip title={isButtonDisabled ? 'Não é possível editar um formulário publicado' : ''} placement="top" arrow>
      <>
        <IconButton disabled={isButtonDisabled} onClick={handleEdit} className={styles.button}>
          <FontAwesomeIcon icon={faEdit} />
        </IconButton>
      </>
    </Tooltip>
  );
};
